import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import { isKeyPrintable } from '../utils';
export function legacyCellInput(event) {
  return isKeyPrintable(event.keyCode) || ['Backspace', 'Delete'].includes(event.key);
}